import { numberLocale } from '@/lib/money';
import { parseTimestamp, shortDate } from '@/lib/relative-time';

function sameDay(a: Date, b: Date) {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

/** "Today 12:14", "Yesterday 21:10" or "13 Oct 18:30". */
export function formatWhen(
  value: string | Date,
  labels: { today: string; yesterday: string },
  locale = 'en'
): string {
  const d = parseTimestamp(value);
  if (Number.isNaN(d.getTime())) return '';
  const time = d.toLocaleTimeString(numberLocale(locale), {
    hour: '2-digit',
    minute: '2-digit',
  });
  const now = new Date();
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (sameDay(d, now)) return `${labels.today} ${time}`;
  if (sameDay(d, yesterday)) return `${labels.yesterday} ${time}`;
  return `${shortDate(d, locale)} ${time}`;
}

/** The `code` of an Axios error body, or undefined. */
export function errorCode(e: unknown): string | undefined {
  const data = (e as { response?: { data?: unknown } })?.response?.data;
  if (data && typeof data === 'object') {
    const d = data as { code?: unknown; error?: unknown };
    if (typeof d.code === 'string') return d.code;
    if (typeof d.error === 'string') return d.error;
  }
  return undefined;
}

export function errorStatus(e: unknown): number | undefined {
  return (e as { response?: { status?: number } })?.response?.status;
}

/** The backend's human message, when it sent one. */
export function errorMessage(e: unknown): string | undefined {
  const data = (e as { response?: { data?: unknown } })?.response?.data;
  if (data && typeof data === 'object') {
    const m = (data as { message?: unknown }).message;
    if (typeof m === 'string' && m) return m;
  }
  return undefined;
}
